<template>
  <div class="nav">
    <div class="topLine"></div>
    <div class="nav_main">
      <div class="nav_main_box">
        <div class="logo left" @click="toIndex">
          <img src="../../assets/images/logo.png" alt="心密之家" title="心密之家">
        </div>
        <ul class="right">
          <router-link v-if="!item.hidden" class="right"  :to="{name:item.name}" tag="li" v-for="(item,index) in meunGroup" :key="index" active-class="active">{{item.meuntxt}}</router-link>
          <!--<li class="right" @click="goToPage(item,index)" :class="{'index':index==meunGroup.length-1,'active':currentIndex==index}" v-for="(item,index) in meunGroup" >{{item.meuntxt}}</li>-->
        </ul>
        <div class="clear clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "menus",
        data() {
            return {
              currentIndex:6,
              meunGroup:[
                {meuntxt:'下载专区',name:'pcDownload',hidden:false},
                {meuntxt:'公告',name:'pcRes',hidden:false},
                {meuntxt:'祖师简介',name:'pcIntroduce',hidden:false},
                {meuntxt:'心密图文',name:'pcPhoto',hidden:false},
                {meuntxt:'心密书库',name:'pcBook',hidden:false},
                {meuntxt:'心密影音',name:'pcVideo',hidden:false},
                {meuntxt:'首页',name:'index',hidden:false}]
            }
        },
        mounted() {

        },
        methods: {
          toIndex(){
            console.log(111)
            this.$router.push({name:'index'})
          }
        }
    }
</script>

<style scoped lang="scss">
  .topLine{
    width:100%;
    height:0.6rem;
    background: #c9a168;
  }
  .nav{
    position: fixed;
    top:0;
    left:0;
    width:100%;
    z-index:10;
  }
  .nav_main {
    width:100%;
    height:8rem;
    background:rgba(255,255,255,0.7);
  .nav_main_box{
    width:95rem;
    margin:0 auto;
    height:100%;
    ul{
      width:86rem;
      li{
        line-height:8rem;
        cursor: pointer;
        margin-left:3.5rem;
        font-size:1.3rem;
        color:#333;
        text-align: center;
        padding:0 0 0 3rem;
      }
      li:last-child{
        margin-left:0;
        padding-left:3rem;
        box-sizing: border-box;
      }
      .index{
        background: url("../../assets/images/index.png") no-repeat left center;
        background-size:2rem auto;
      }
      .active{
        color:#5f4009;
        background: url("../../assets/images/index.png") no-repeat 0 center;
        background-size:2rem auto;
      }
    }
  .logo{
    height:8rem;
    cursor: pointer;
    width:9rem;
    position: relative;
  img{
    width:8.6rem;
    height:5.3rem;
    position: absolute;
    top:50%;
    margin-top:-2.65rem;
   }
  }
 }
}
</style>



// WEBPACK FOOTER //
// src/components/nav/menus.vue